import { emailDomainAuthenticatorService } from "../services/emailDomainAuthenticator.service";
import { emailDomainAuthenticatorConstants } from "../constants/emailDomainAuthenticator.constants";

export const emailDomainAuthenticatorActions = {
  getById,
  get,
  create,
  remove,
  update,
};

function getById(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    emailDomainAuthenticatorService.getById(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: emailDomainAuthenticatorConstants.GET_BYID_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: emailDomainAuthenticatorConstants.GET_BYID_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: emailDomainAuthenticatorConstants.GET_BYID_FAILURE };
  }
}

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    emailDomainAuthenticatorService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: emailDomainAuthenticatorConstants.GET_REQUEST,
      payload: requestParameters,
    };
  }
  function success(paginatedResult) {
    return {
      type: emailDomainAuthenticatorConstants.GET_SUCCESS,
      payload: paginatedResult,
    };
  }
  function failure() {
    return { type: emailDomainAuthenticatorConstants.GET_FAILURE };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    emailDomainAuthenticatorService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: emailDomainAuthenticatorConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: emailDomainAuthenticatorConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: emailDomainAuthenticatorConstants.CREATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    emailDomainAuthenticatorService.remove(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: emailDomainAuthenticatorConstants.DELETE_REQUEST,
    };
  }
  function success() {
    return { type: emailDomainAuthenticatorConstants.DELETE_SUCCESS };
  }
  function failure() {
    return { type: emailDomainAuthenticatorConstants.DELETE_FAILURE };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    emailDomainAuthenticatorService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: emailDomainAuthenticatorConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: emailDomainAuthenticatorConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: emailDomainAuthenticatorConstants.UPDATE_FAILURE };
  }
}
